// @ts-ignore //Weird CSS issues...
import "./index.css";

import { NavBar } from "./components/navBar";
import { Hero1 } from "./components/Hero";
import { QuoteForm } from "./components/QuoteForm";
import { Services } from "./components/Services";
import { WhyUs } from "./components/WhyUs";
import { Gallery } from "./components/Gallery";
import { Testimonials } from "./components/Testimonials";
import { FAQ } from "./components/FAQ";
import { CallToAction } from "./components/CallToAction";
import { Footer } from "./components/Footer";

export function App() {
  return (
    <div className="flex min-h-screen flex-col bg-background text-foreground">
      <NavBar />
      <main className="flex-1">
        <Hero1 />
        <div className="relative z-10 mx-auto -mt-12 max-w-360 px-4 sm:-mt-16 md:px-8 lg:-mt-8">
          <QuoteForm />
        </div>
        <Services />
        <WhyUs />
        <Gallery />
        <Testimonials />
        <FAQ />
        <CallToAction />
      </main>
      <Footer />
    </div>
  );
}

export default App;
